module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc_head"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/004_Acknowledge#ack"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/005_Introduction#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/006_Chapter_1#chapter1"
    }
  }, [_vm._v("1921–1929")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/007_Chapter_2#chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1930–1939")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/008_Chapter_3#chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1940–1949")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_4#chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1950–1959")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_5#chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1960–1969")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_6#chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1970–1979")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_7#chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1980–1989")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/013_Chapter_8#chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1990–1999")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/014_Chapter_9#chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2000–2009")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/015_final#final",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Final Years: 2010–2014 "), _c('em', {
    staticClass: "italic"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132b06ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 66
// module chunks = 0